import styled from '@emotion/styled';
import Box from '@mui/material/Box';
import ListItem from '@mui/material/ListItem';

export const DrawerContainer = styled(Box)({
  display: 'grid',
});

export const DrawerContent = styled(Box)({
  display: 'grid',
  margin: '10px',
  padding: '10px',
  alignItems: 'center',
});

export const CategoryContainer = styled(Box)(({ theme }) => ({
  backgroundColor: 'white',
  color: theme.palette.primary.main,
  borderColor: theme.palette.primary.main,
  borderRadius: '5px',
  border: '1px solid',
  marginBottom: '10px',
}));

export const ListItemStyled = styled(ListItem)(({ theme }) => ({
  padding: '2px 0',
  borderRadius: '5px',
  border: '1px',
  borderColor: theme.palette.primary.main,
  display: 'flex',
  alignItems: 'center',
  height: '38px',
}));

export const SubmenuContainer = styled(Box)({
  marginLeft: '24px',
  color: 'black',
  display: 'grid',
});
